import api from "Services/API";
import { Credentials, LoginResponseType } from "./LoginService.props";
import { ENDPOINTS } from "Services/Endpoints";

export const sendOtp = (data: Pick<Credentials, "phone">) => {
    return api.post<LoginResponseType | null>(`${ENDPOINTS.SEND_OTP}/${data.phone}`);
};
export const login = (data: Credentials) => {
    return api.post<LoginResponseType | null>(ENDPOINTS.AUTH, data);
};